import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_VIDEO_MEETINGS } from '@/api/endpoints';
import { VIDEO_MEETING_QUERY_KEY } from '@/api/queryKeys';
import { toVideoMeetingDetails } from '@/pages/Mail/videoMeetings';
import type { VideoMeeting, VideoMeetingDetailsResponse } from '@/types/video';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

export const useVideoMeeting = (meetingId: string) =>
  useQuery<VideoMeeting>({
    queryKey: [...VIDEO_MEETING_QUERY_KEY, meetingId],
    queryFn: () =>
      apiClient
        .get<VideoMeetingDetailsResponse>(
          joinPath(API_VIDEO_MEETINGS, meetingId),
        )
        .then(unwrapAxiosResponse)
        .then(toVideoMeetingDetails),
  });
